<mat-card
  *ngIf="sessionList.length != 0"
  class="process-box p-0 m-0"
  style="
    width: 300px;
    box-shadow: 0 7px 11px rgba(47, 60, 74, 0.04),
      0 2px 6px rgba(47, 60, 74, 0.2) !important;
  "
  [@animate]="{ value: '*', params: { y: '50px', delay: '300ms' } }"
>
  <div fxLayout="row">
    <button
      class="card-control ml-auto"
      mat-icon-button
      (click)="sessionList = []"
    >
      <mat-icon style="font-size: 18px">close</mat-icon>
    </button>
  </div>
  <div class="p-8">
    <div
      *ngFor="let item of sessionList"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <div style="font-size: 0.7rem">{{ item.taskName || "Lên đơn" }}</div>
      <div fxLayout="row" fxLayoutAlign="center center">
        <mat-progress-spinner
          diameter="15"
          class="mr-8"
          color="#0081ff"
          [value]="item.persent"
          mode="determinate"
        ></mat-progress-spinner
        >{{ item.persent }}%
      </div>
    </div>
  </div>
</mat-card>
